import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
import {
	HENI_TAG_PARAM,
	HENI_TAG_PARAM_VALUE,
} from '#lib/websites/news/constants/heni-tag.js';

export const getHeniTagLink = (showGlobalNav: boolean) =>
	`${GlobalRoutes.NewsHome}${
		showGlobalNav
			? `?${HENI_TAG_PARAM}=${HENI_TAG_PARAM_VALUE}`
			: `?global_nav=0&${HENI_TAG_PARAM}=${HENI_TAG_PARAM_VALUE}`
	}`;
